import { cn } from "@/lib/utils";

/**
 * Microsoft Teams glyph as used across the consultation timeline (LAT-626, Pencil
 * `teamsBadge`): a Teams-purple square with a white "T" — square corners to match
 * the app's flat aesthetic, not the monochrome multi-path logo (which rendered as a
 * filled blob under `currentColor`).
 *
 * Sized in pixels so the letter scales with the box (the design uses 13/14/16px).
 * `className` is for extra tweaks only (e.g. opacity on muted log lines); the
 * purple/white fill is intrinsic to the badge.
 */
export function TeamsIcon({ size = 16, className }: { size?: number; className?: string }) {
  return (
    <span
      aria-hidden="true"
      data-testid="teams-icon"
      className={cn(
        "inline-flex shrink-0 items-center justify-center bg-[#6264A7] font-bold leading-none text-white",
        className
      )}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.6) }}
    >
      T
    </span>
  );
}
